import { render, staticRenderFns } from "./ReactivateProModal.vue?vue&type=template&id=212c8fe4&scoped=true&"
import script from "./ReactivateProModal.vue?vue&type=script&lang=ts&"
export * from "./ReactivateProModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReactivateProModal.vue?vue&type=style&index=0&id=212c8fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c8fe4",
  null
  
)

export default component.exports